import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, MenuButton } from '@maui/elements'
import { Dropdown } from '../Dropdown'

export const Label = Box.extend({
  display: 'flex',
})

export const Divider = Box.extend({
  padding: '0 0.4em',
  display: 'inline',
  _before: {
    content: '"|"',
  }
})

const Trigger = ({ children, ...props }) => (
  <MenuButton
    variant="unstyled"
    p="0"
    border="0"
    fontWeight="normal"
    fontSize="inherit"
    gap="4px"
    color="colorActivePrimary"
    {...props}
  >
    {children}
    <Icon name="chevron-down" />
  </MenuButton>
)

export const InlineDropdown = ({ label, trigger, ...restProps }) => {
  return (
    <Box
      display="inline-flex"
      flexDirection="row"
      alignItems="flex-end"
    >
      {label && <>
        <Label>{label}</Label>
        <Divider />
      </>}
      <Dropdown
        trigger={typeof trigger === 'string'
          ? <Trigger>{trigger}</Trigger>
          : trigger
        }
        {...restProps}
      />
    </Box>
  )
}

InlineDropdown.Link = Dropdown.Link
InlineDropdown.Divider = Divider
InlineDropdown.Group = Dropdown.Group
InlineDropdown.Item = Dropdown.Item
InlineDropdown.Label = Label
InlineDropdown.Trigger = Trigger

InlineDropdown.propTypes = {
  label: PropTypes.node,
  trigger: PropTypes.node,
}
